import React from "react";
import ReactDOM from "react-dom";
import { ClientFooter } from "./components/HeaderFooter/ClientFooter";

if (typeof global !== "undefined") {
  (global as any).ClientFooter = ClientFooter;
}
if (typeof window !== "undefined") {
  (window as any).ClientFooter = ClientFooter;
}

const clientFooter = document.getElementById("clientFooter");
if (clientFooter) {
  if (clientFooter.hasChildNodes()) {
    ReactDOM.hydrate(<ClientFooter baseUrl={(window as any)["BaseUrl"]} year={(window as any)["Year"]} />, clientFooter);
  } else {
    ReactDOM.render(<ClientFooter baseUrl={(window as any)["BaseUrl"]} year={(window as any)["Year"]} />, clientFooter);
  }
}
